import {ICompany} from "@/common/types";

export const isAria  = (company: ICompany) => {
    return (company.id === '67d40aea-9649-42a1-8412-5153b3ab3d96')
}
export const isBios  = (company: ICompany) => {
    return (company.id === '54525aa3-bb60-4b8d-9a3e-3aa73a0ad79c')
}
